import { Link } from 'react-router-dom';
import { getRedirectUrlOutOfOAuthUrl } from '../lib/helpers';

export default function FormExtra() {
  // grab the redirect url out of the path to tack onto the reset
  const redirectUri = getRedirectUrlOutOfOAuthUrl();
  return (
    <div className="flex items-center justify-between ">
      <div className="flex items-center">
        {/* <input
          id="remember-me"
          name="remember-me"
          type="checkbox"
          className="h-4 w-4 text-eirly-600 focus:ring-eirly-500 border-gray-300 rounded"
        />
        <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900">
          Remember me
        </label> */}
      </div>

      <div className="text-sm">
        <Link
          to={`/reset/password${
            redirectUri ? `?redirectUrl=${redirectUri}` : ''
          }`}
          className="font-medium text-zinc-500 hover:text-gray-600 underline"
        >
          Forgot your password?
        </Link>
      </div>
    </div>
  );
}
